import React from 'react';
import CallInbound from './call-inbound';
import CallOutbound from './call-outboundf';
import CallInProgress from './call-inprogress';
import { useCallSelector } from '../../hooks/use-phone';
import { usePhoneWarnings } from '../../hooks/use-phone/use-phone-warning';
import WarningMicrophoneCall from '../warning-microphone/warning-microphone-call';
import WarningMicPermissionsCall from '../warning-microphone/warning-mic-permissions-call';


export default function CallControl(props: { callId: string }) {
    const progress = useCallSelector(props.callId, x => x.progress);
    const direction = useCallSelector(props.callId, x => x.direction);

    const { warning: error, showWarning } = usePhoneWarnings();

    function CallElement() {
        return (
            <>
                {progress === 'initiating' ? (
                    direction === 'inbound' ? (
                        <CallInbound callId={props.callId} />
                    ) : (
                        <CallOutbound callId={props.callId} />
                    )
                ) : (
                    <CallInProgress callId={props.callId} />
                )}
                {error === 'nomicrophone' && <WarningMicrophoneCall />}
                {error === 'nomicpermissions' && <WarningMicPermissionsCall />}
            </>
        );
    }

    if (progress === 'ended') return null;

    return <> {!!props.callId && CallElement()} </>;
}
